<template>
  <div class="ForumResponseBodyTextOutput">
    <ForumResponseBodyTextOutputNode
      v-for="(node, idx) in ast"
      :key="idx"
      :node="node"
      :basic-mention="basicMention"
      :chat-id="chatId"
    />
  </div>
</template>

<script>
import sanitizeHtml from 'sanitize-html'
import emojiToHtml from '@/utils/emojiToHtml'
import ForumResponseBodyTextOutputNode from '@/components/pages/forum/response/body/text/ForumResponseBodyTextOutputNode.vue'

const allowedTags = ['strong', 'em', 'ol', 'br', 'u', 'p', 'ul', 'li', 'a']

export default {
  name: 'ForumResponseBodyTextOutput',
  components: { ForumResponseBodyTextOutputNode },
  props: {
    text: { type: String, default: '' },
    basicMention: { type: Boolean, default: true },
    chatId: { type: [Number, String], default: null }
  },
  computed: {
    ast() {
      return this.parseHtmlToAst(this.sanitizedHtml())
    }
  },
  methods: {
    sanitizedHtml() {
      return emojiToHtml.span(
        sanitizeHtml(this.text, {
          allowedTags
        })
      )
    },
    parseHtmlToAst(html) {
      const container = document.createElement('div')
      container.innerHTML = html
      return this.walkNodes(container)
    },
    walkNodes(node) {
      const result = []
      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.ELEMENT_NODE) {
          result.push({
            type: 'element',
            tag: child.tagName.toLowerCase(),
            attrs: this.getAttrs(child),
            children: this.walkNodes(child)
          })
        } else if (child.nodeType === Node.TEXT_NODE) {
          const regex = /{{mention:(.*?)}}/gi
          let lastIndex = 0
          const text = child.textContent
          let match
          while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
              result.push({
                type: 'text',
                value: text.slice(lastIndex, match.index)
              })
            }
            result.push({
              type: 'mention',
              options: JSON.parse(JSON.parse(match[1]))
            })
            lastIndex = regex.lastIndex
          }
          if (lastIndex < text.length) {
            result.push({
              type: 'text',
              value: text.slice(lastIndex)
            })
          }
        }
      })
      return result
    },
    getAttrs(node) {
      const attrs = {}
      for (const attr of node.attributes || []) {
        attrs[attr.name] = attr.value
      }
      return attrs
    }
  }
}
</script>

<style scoped lang="scss">
.ForumResponseBodyTextOutput {
}
</style>
